import { render, staticRenderFns } from "./referanscomp.vue?vue&type=template&id=ed35c8ec"
import script from "./referanscomp.vue?vue&type=script&lang=js"
export * from "./referanscomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports